import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection,AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable,Subscription } from 'rxjs';
import { Events} from 'ionic-angular';
import { first } from 'rxjs/operators';
import { User } from  '../../models/user';
import { Storage } from '@ionic/storage';
import { map } from 'rxjs/operators';
/*
  Generated class for the CommonProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CommonProvider {
  
   countries:Array<any> = [];
   constructor(private afs: AngularFirestore,private storage: Storage, public events:Events) {
    console.log('Hello OemProvider Provider');
  }


   intializeSubscriptions(){

   	this.fetchCountries();


   }

   removeSubscriptions(){
   
   }

   async fetchCountries(){
   		this.countries = await this.afs.collection('countries', ref => ref.orderBy('order')).valueChanges().pipe(first()).toPromise();
   		this.storage.set('countries',this.countries);
   		console.log(this.countries);
   }

}



// WEBPACK FOOTER //
// ./src/providers/common/common.ts